import script from "./ProjectPickerSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectPickerSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectPickerSidebar.vue?vue&type=style&index=0&id=6f51159c&lang=scss"

const __exports__ = script;

export default __exports__